import { render, staticRenderFns } from "./BusAttendance.vue?vue&type=template&id=020881a0&scoped=true"
import script from "./BusAttendance.vue?vue&type=script&lang=js"
export * from "./BusAttendance.vue?vue&type=script&lang=js"
import style0 from "./BusAttendance.vue?vue&type=style&index=0&id=020881a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020881a0",
  null
  
)

export default component.exports